/***
 * Functions related to service management
 */
import {
  getServiceList,
  getUser,
  setUser,
} from "../services/CurrentUser/currentUserLocalStorage";

export function getDefaultServiceType() {
  const defaultServiceType = getUser().serviceType;

  if (isMobileService(defaultServiceType)) {
    return "mobile";
  }
  if (isFBBService(defaultServiceType)) {
    return "fixed";
  }
  if (isSmartSurfService(defaultServiceType)) {
    return "smart-surf";
  }

  // no service found, return empty string
  return "";
}

export function findDefaultServicePrimaryId() {
  const defaultServiceId = getUser().DefaultServiceID;
  const serviceList = getServiceList().serviceList;

  const defaultService =
    serviceList?.length > 0 &&
    serviceList.find((service) => {
      if (!!service.ID && service.ID === defaultServiceId) {
        return true;
      }
      return false;
    });

  if (!!defaultService && !!defaultService.primaryID) {
    return defaultService.primaryID;
  }
  return "";
}

export function getUsersDefaultService() {
  const defaultServiceId = getUser().DefaultServiceID;
  const serviceList = getServiceList().serviceList;

  const defaultService =
    serviceList?.length > 0 &&
    serviceList.find(
      (service) => !!service.ID && service.ID === defaultServiceId
    );

  if (!!defaultService) {
    return defaultService;
  } else {
    return null;
  }
}

export function findServiceIdWithPrimaryId(primaryId) {
  const serviceList = getServiceList().serviceList;

  const desiredService = serviceList.find((service) => {
    if (!!service.primaryID && service.primaryID === primaryId) {
      return true;
    }
    return false;
  });

  if (!!desiredService && !!desiredService.ID) {
    return desiredService.ID;
  }
  return "";
}

export function updateUserWithDefaultService(serviceData) {
  try {
    // clone current user in local storage
    const currentUser = { ...getUser() };

    // get default service data from full service data
    const service = serviceData.DefaultService;

    // format display name
    const displayNameOriginal = service.DisplayName.toLowerCase();
    const displayName =
      displayNameOriginal.charAt(0).toUpperCase() +
      displayNameOriginal.slice(1);

    // update cloned users service details
    currentUser.DisplayName = displayName;
    currentUser.msisdn = service.primaryID;
    currentUser.DefaultServiceID = service.ID;
    currentUser.serviceType = service.Type;
    currentUser.primaryID = service.primaryID;
    currentUser.SecondaryID = service.SecondaryID;
    currentUser.ContactPhone = service.ContactPhone;
    currentUser.FirstName = service.FirstName;
    currentUser.LastName = service.LastName;
    currentUser.ContactEmail = service.ContactEmail;

    // update the user in local storage with cloned user
    setUser(currentUser);
  } catch (error) {
    // console.error('update service details error', error)
  }
}

function isMobileService(defaultServiceType) {
  if (
    defaultServiceType === "PHONE_MOBILE_PRE_P" ||
    defaultServiceType === "PHONE_MOBILE_HYBRID" ||
    defaultServiceType === "PHONE_MOBILE_POST_P"
  ) {
    return true;
  }
  return false;
}

function isFBBService(defaultServiceType) {
  if (
    defaultServiceType === "BB_FIXED_PRE_P" ||
    defaultServiceType === "BB_FIXED_POST_P"
  ) {
    return true;
  }
  return false;
}

function isSmartSurfService(defaultServiceType) {
  if (defaultServiceType === "BB_FIXED_SMART") {
    return true;
  }
  return false;
}


export const getInitials = (name) => {
  const splitName = name?.split(/\s+/).filter(item=>item) || ""
  const initials = splitName?.length && splitName.map(item => item[0]);
  const firstTwo = initials.length && initials?.slice(0, 2).join("");
  return firstTwo?.toUpperCase();
};

export const getHasLoginStatus = () => {
  let loginStatus = false
  if(typeof localStorage !== "undefined") {
    loginStatus = localStorage.getItem("hasLogin") === "true";
  }
  // loginStatus = localStorage.getItem("hasLogin") === "true";
  return loginStatus;
}

export function findServiceType(serviceType) {
  if (isMobileService(serviceType) || isFBBService(serviceType)) {
    return "individual";
  } else{
       //create conditionforenterpriseuser
    return "company"
  } 
}





